import React from "react";
import { ListItem, Typography, Paper, List, Box } from "@mui/material";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import { Link } from "react-router-dom";
import SplitDescription from "../components/splitdescription";
import PageIntro from "../components/pageintro";
import ServicesGridCards from "../components/servicesgrid";
import WhyTecloqCards from "../components/whytecloqcards";

const whydata = [
    {
      src: "/assets/BigData/DataWarehouse/Frame1.png",
      alt: "why1",
      title: "Big Data Solutions",
      description:
        "Uncover hidden insights from massive datasets with our cutting-edge big data solutions, empowering your business to make informed decisions at scale.",
    },
    {
      src: "/assets/BigData/DataWarehouse/Frame2.png",
      alt: "why1",
      title: "Business Intelligence",
      description:
        "Transform raw data into actionable insights and visualizations that drive strategic decision-making, using our business intelligence services to gain a competitive edge.",
    },
    {
      src: "/assets/BigData/DataWarehouse/Frame3.png",
      alt: "why1",
      title: "Artificial Intelligence",
      description:
        "Harness the power of artificial intelligence to drive innovation and automation in your processes, creating smarter systems and enhancing customer experiences with our AI solutions.",
    },
  ];
  

const offeringdata = [
    {
      src: "/assets/BigData/DataWarehouse/image1.png",
      alt: "text analysis",
      width: "65%",
      paddingTop: "10%",
      text: "Data Warehouse Implementation"
    },
    {
      src: "/assets/BigData/DataWarehouse/image2.png",
      alt: "text analysis",
      width: "65%",
      paddingTop: "10%",
      text: "Data Warehouse Analytics"
    },
    {
      src: "/assets/BigData/DataWarehouse/image3.png",
      alt: "text analysis",
      width: "65%",
      paddingTop: "10%",
      text: "Data Observability"
    },
    {
      src: "/assets/BigData/DataWarehouse/image4.png",
      alt: "text analysis",
      width: "65%",
      paddingTop: "10%",
      text: "Data Warehouse Consulting"
    },
    {
      src: "/assets/BigData/DataWarehouse/image5.png",
      alt: "text analysis",
      width: "65%",
      paddingTop: "5%",
      text: "Cloud Migration"
    },
    {
      src: "/assets/BigData/DataWarehouse/image6.png",
      alt: "text analysis",
      width: "65%",
      paddingTop: "0%",
      text: "Support & Assistance"
    }
  ];
  

const DataWarehouse = () => {
  return (
    <Box>
      <PageIntro
        bg={"/assets/BigData/DataWarehouse/banner.webp"}
        subheading={"Handle Data Deluge with Precision Through Tecloq’s"}
        heading={"Data Warehouse Solutions"}
        desc={"Architecting Future-Ready Data Landscapes"}
      />

      <SplitDescription
        heading1={"Advanced Data Warehousing for Driving Informed Decisions"}
        content1={
          "In an era defined by data, businesses are creating and collecting vast volumes of information from diverse sources. As this data continues to grow exponentially, harnessing its potential becomes a strategic advantage for any organization. Tecloq’s Data Warehousing services empower your business to make informed decisions, gain valuable insights, and optimize operations through a robust and scalable data warehousing solution."
        }
        img1={"/assets/BigData/DataWarehouse/bannerSub.png"}
      />

      {/* <Paper elevation={0} sx={{ display:"flex", margin:"8% 3% 5% 9%", flexDirection:"row", padding:"0 !important", height:"auto"}}>
                       <section style={{width:"150%"}}>
                           <Typography style={{fontFamily:"Orbitron", fontWeight:"800", fontSize:"40px",
                           color:"#000000", lineHeight:"120%", letterSpacing:"2%", display:"flex", 
                           justifyContent:"flex-start", paddingBottom:"8%"}}>
                           Advanced Data Warehousing for Driving Informed Decisions
                           </Typography>
                           <Typography style={{fontFamily:"Inter", fontWeight:"normal", color:"#000000", fontSize:"24px"}}>
                           In an era defined by data, businesses are creating and collecting vast volumes of information from diverse sources. As this data continues to grow exponentially, harnessing its potential becomes a strategic advantage for any organization. Tecloq’s Data Warehousing services empower your business to make informed decisions, gain valuable insights, and optimize operations through a robust and scalable data warehousing solution.
                           </Typography>
                       </section>
                       <section>
                           <img
                               src="/assets/BigData/DataWarehouse/bannerSub.png"
                               loading='lazy'
                               alt='ourgoal'
                               style={{height:"auto", width:"80%", margin:"22% 0 0 15%"}}
                               >
                           </img>
                       </section>
         </Paper> */}

      <Box
        sx={{
          maxWidth: "100%",
          height: "auto",
          marginTop: "3%",
        }}
      >
        <Typography
          sx={{
            fontFamily: "Orbitron",
            fontWeight: "800",
            fontSize: { xs: "24px", sm: "30px", md: "40px" }, // Responsive font size
            color: "#000000",
            lineHeight: "120%",
            letterSpacing: "2%",
            display: "flex",
            justifyContent: "center",
            paddingBottom: { xs: "2%", md: "1%" }, // Responsive padding
            textAlign: "center", // Centered alignment on smaller screens
          }}
        >
          Our Data Warehousing Services
        </Typography>
      </Box>

      <ServicesGridCards data={offeringdata}/>

      {/* <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          flexWrap: "wrap",
          "& > :not(style)": {
            m: 1,
            width: 400,
            height: 340,
          },
          gap: "20px",
        }}
      >
        <Paper
          elevation={3}
          sx={{ borderRadius: "5%", textAlign: "center", paddingTop: "3%" }}
        >
          <img
            src="/assets/BigData/DataWarehouse/image1.png"
            loading="lazy"
            alt="text analysis"
            style={{ boxSizing: "border-box", width: "65%", height: "auto" }}
          ></img>
          <Typography
            style={{
              fontFamily: "Inter",
              fontStyle: "normal",
              fontWeight: "700",
              fontSize: "16px",
              lineHeight: "21px",
              alignItems: "center",
              textAlign: "center",
              color: "#000000",
              paddingTop: "10%",
            }}
          >
            Data Warehouse <br />
            Implementation
          </Typography>
        </Paper>
        <Paper
          elevation={3}
          sx={{ borderRadius: "5%", textAlign: "center", paddingTop: "3%" }}
        >
          <img
            src="/assets/BigData/DataWarehouse/image2.png"
            loading="lazy"
            alt="text analysis"
            style={{ boxSizing: "border-box", width: "65%", height: "auto" }}
          ></img>
          <Typography
            style={{
              fontFamily: "Inter",
              fontStyle: "normal",
              fontWeight: "700",
              fontSize: "16px",
              lineHeight: "21px",
              alignItems: "center",
              textAlign: "center",
              color: "#000000",
              paddingTop: "10%",
            }}
          >
            Data Warehouse <br />
            Analytics
          </Typography>
        </Paper>
        <Paper
          elevation={3}
          sx={{ borderRadius: "5%", textAlign: "center", paddingTop: "3%" }}
        >
          <img
            src="/assets/BigData/DataWarehouse/image3.png"
            alt="text analysis"
            loading="lazy"
            style={{ boxSizing: "border-box", width: "65%", height: "auto" }}
          ></img>
          <Typography
            style={{
              fontFamily: "Inter",
              fontStyle: "normal",
              fontWeight: "700",
              fontSize: "16px",
              lineHeight: "21px",
              alignItems: "center",
              textAlign: "center",
              color: "#000000",
              paddingTop: "10%",
            }}
          >
            Data Observability
          </Typography>
        </Paper>
        <Paper
          elevation={3}
          sx={{ borderRadius: "5%", textAlign: "center", paddingTop: "3%" }}
        >
          <img
            src="/assets/BigData/DataWarehouse/image4.png"
            alt="text analysis"
            loading="lazy"
            style={{ boxSizing: "border-box", width: "65%", height: "auto" }}
          ></img>
          <Typography
            style={{
              fontFamily: "Inter",
              fontStyle: "normal",
              fontWeight: "700",
              fontSize: "16px",
              lineHeight: "21px",
              alignItems: "center",
              textAlign: "center",
              color: "#000000",
              paddingTop: "10%",
            }}
          >
            Data Warehouse <br /> Consulting
          </Typography>
        </Paper>
        <Paper
          elevation={3}
          sx={{ borderRadius: "5%", textAlign: "center", paddingTop: "3%" }}
        >
          <img
            src="/assets/BigData/DataWarehouse/image5.png"
            alt="text analysis"
            loading="lazy"
            style={{ boxSizing: "border-box", width: "65%", height: "auto" }}
          ></img>
          <Typography
            style={{
              fontFamily: "Inter",
              fontStyle: "normal",
              fontWeight: "700",
              fontSize: "16px",
              lineHeight: "21px",
              alignItems: "center",
              textAlign: "center",
              color: "#000000",
              paddingTop: "5%",
            }}
          >
            Cloud Migration
          </Typography>
        </Paper>
        <Paper
          elevation={3}
          sx={{ borderRadius: "5%", textAlign: "center", paddingTop: "3%" }}
        >
          <img
            src="/assets/BigData/DataWarehouse/image6.png"
            alt="text analysis"
            loading="lazy"
            style={{ boxSizing: "border-box", width: "65%", height: "auto" }}
          ></img>
          <Typography
            style={{
              fontFamily: "Inter",
              fontStyle: "normal",
              fontWeight: "700",
              fontSize: "16px",
              lineHeight: "21px",
              alignItems: "center",
              textAlign: "center",
              color: "#000000",
              paddingTop: "0%",
            }}
          >
            Support & Assistance
          </Typography>
        </Paper>
      </Box> */}


<Box
  sx={{
      maxWidth: "100%",
      height: "auto",
      marginTop: { xs: "3%", md: "6%" },
      paddingX: { xs: "5%", md: "0" },
    }}
>
  <Typography
    sx={{
      fontFamily: "Orbitron",
      fontWeight: "800",
      fontSize: { xs: "24px", md: "40px" },
      color: "#000000",
      lineHeight: "120%",
      letterSpacing: "2%",
      display: "flex",
      justifyContent: "center",
      paddingBottom: "1%",
      marginTop: {xs:"15%"}
    }}
  >
    The Tecloq Advantage
  </Typography>
  <Typography
    sx={{
      fontFamily: "Inter",
      fontWeight: "lighter",
      fontSize: { xs: "14px", md: "20px" },
      color: "#000000",
      display: "flex",
      justifyContent: "center",
      margin: { xs: "2% 5%", md: "1% 18% 2%" },
      textAlign: "center",
    }}
  >
    We stand out as a leading data warehouse service provider, armed with
    diverse cross-industry expertise. Unleash the hidden potential of your
    digital information with our top-notch solutions.
  </Typography>
</Box>


    <WhyTecloqCards data={whydata} />
       


      {/* <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          flexWrap: "wrap",
          "& > :not(style)": {
            m: 1,
            width: 370,
            height: 550,
          },
          gap: "3%",
          marginBottom: "30px",
        }}
      >
        <Paper
          elevation={3}
          sx={{
            borderRadius: "3%",
            textAlign: "center",
            border: "0.5px solid #FFC3EA",
            alignContent: "center",
            boxShadow: "0px -3px 17px rgba(240, 5, 162, 0.52)",
            display: "flex",
            flexDirection: "column",
            background:
              "linear-gradient(153.3deg, #FFFFFF 8.98%, #FFEAF8 89.37%)",
          }}
        >
          <img
            src="/assets/BigData/DataWarehouse/Frame1.png"
            alt="why1"
            loading="lazy"
            style={{
              width: "65%",
              height: "auto",
              margin: "0 auto",
              paddingTop: "15%",
            }}
          ></img>
          <Typography
            sx={{
              fontFamily: "Orbitron",
              lineHeight: "120%",
              fontSize: "28px",
              fontStyle: "normal",
              fontWeight: "700",
              color: "#F005A2",
              letterSpacing: "2%",
            }}
          >
            Big Data Solutions
          </Typography>
          <Typography
            sx={{
              fontFamily: "Inter",
              fontStyle: "normal",
              lineHeight: "auto",
              padding: "10% 10% 3% 10%",
            }}
          >
            Uncover hidden insights from massive datasets with our cutting-edge
            big data solutions, empowering your business to make informed
            decisions at scale.
          </Typography>
        </Paper>
        <Paper
          elevation={3}
          sx={{
            borderRadius: "3%",
            textAlign: "center",
            border: "0.5px solid #FFC3EA",
            alignContent: "center",
            boxShadow: "0px -3px 17px rgba(240, 5, 162, 0.52)",
            display: "flex",
            flexDirection: "column",
            background:
              "linear-gradient(153.3deg, #FFFFFF 8.98%, #FFEAF8 89.37%)",
          }}
        >
          <img
            src="/assets/BigData/DataWarehouse/Frame2.png"
            alt="why1"
            loading="lazy"
            style={{
              width: "65%",
              height: "auto",
              margin: "0 auto",
              paddingTop: "15%",
            }}
          ></img>
          <Typography
            sx={{
              fontFamily: "Orbitron",
              lineHeight: "120%",
              fontSize: "28px",
              fontStyle: "normal",
              fontWeight: "700",
              color: "#F005A2",
              letterSpacing: "2%",
            }}
          >
            Business Intelligence
          </Typography>
          <Typography
            sx={{
              fontFamily: "Inter",
              fontStyle: "normal",
              lineHeight: "auto",
              padding: "10% 10% 3% 10%",
            }}
          >
            Transform raw data into actionable insights and visualizations that
            drive strategic decision-making, using our business intelligence
            services to gain a competitive edge.
          </Typography>
        </Paper>
        <Paper
          elevation={3}
          sx={{
            borderRadius: "3%",
            textAlign: "center",
            border: "0.5px solid #FFC3EA",
            alignContent: "center",
            boxShadow: "0px -3px 17px rgba(240, 5, 162, 0.52)",
            display: "flex",
            flexDirection: "column",
            background:
              "linear-gradient(153.3deg, #FFFFFF 8.98%, #FFEAF8 89.37%)",
          }}
        >
          <img
            src="/assets/BigData/DataWarehouse/Frame3.png"
            loading="lazy"
            alt="why1"
            style={{
              width: "65%",
              height: "auto",
              margin: "0 auto",
              paddingTop: "15%",
            }}
          ></img>
          <Typography
            sx={{
              fontFamily: "Orbitron",
              lineHeight: "120%",
              fontSize: "28px",
              fontStyle: "normal",
              fontWeight: "700",
              color: "#F005A2",
              letterSpacing: "2%",
            }}
          >
            Artificial Intelligence
          </Typography>
          <Typography
            sx={{
              fontFamily: "Inter",
              fontStyle: "normal",
              lineHeight: "auto",
              padding: "10% 10% 3% 10%",
            }}
          >
            Harness the power of artificial intelligence to drive innovation and
            automation in your processes, creating smarter systems and enhancing
            customer experiences with our AI solutions.
          </Typography>
        </Paper>
      </Box> */}
    </Box>
  );
};

export default DataWarehouse;
